import React from "react";
import { useLocation } from "react-router-dom";
export const BackGround = () => {
  let location = useLocation();
  return (
    <>
      {location.pathname === "/myapp/adminpage" ? (
        <div className="PageBg_Cover PageBg_Cover_Adminpage"></div>
      ) : (
        <div className="PageBg_Cover PageBg_Cover_regular"></div>
      )}
    </>
  );
};

export const SideIcons = () => {
  return (
    <>
      <div className="Side_icons">
        <div className="icons twitter ">
          <a href="https://twitter.com/i/flow/login" target={"blank"}>
            <svg
              width="31"
              height="25"
              viewBox="0 0 31 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M30.0425 3.72556C28.9561 4.1942 27.7738 4.53148 26.5561 4.66284C27.8204 3.91173 28.7672 2.72509 29.2188 1.32557C28.0324 2.03133 26.7327 2.52622 25.3774 2.78829C24.8109 2.1827 24.1258 1.70026 23.3647 1.37104C22.6037 1.04181 21.783 0.872847 20.9537 0.874679C17.5987 0.874679 14.9005 3.5942 14.9005 6.93148C14.9005 7.40012 14.9573 7.86876 15.0496 8.31965C10.0259 8.05692 5.54546 5.65692 2.56676 1.98237C2.02401 2.90941 1.73959 3.96495 1.74309 5.03917C1.74309 7.14095 2.81173 8.9942 4.44131 10.0841C3.48098 10.0463 2.54312 9.78236 1.70404 9.31373V9.38828C1.70404 12.3315 3.78451 14.7705 6.55729 15.3315C6.03667 15.4667 5.5011 15.5359 4.96321 15.5374C4.56912 15.5374 4.19634 15.4983 3.82001 15.4451C4.58688 17.8451 6.82001 19.5883 9.47918 19.6451C7.39871 21.2747 4.79279 22.2332 1.96321 22.2332C1.45552 22.2332 0.986879 22.2155 0.500488 22.1587C3.18451 23.8806 6.36912 24.8747 9.79871 24.8747C20.9324 24.8747 27.0247 15.651 27.0247 7.64509C27.0247 7.38237 27.0247 7.11965 27.007 6.85692C28.1857 5.9942 29.2188 4.92556 30.0425 3.72556Z"
                fill="#F5E6BD"
              />
            </svg>
          </a>
        </div>
        <div className="icons web">
          <a href="https://en.wikipedia.org/wiki/Main_Page" target={"blank"}>
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.76367 17.1253C9.76897 18.6953 9.96561 20.2589 10.3492 21.7814H16.4692V12.828H10.2642C9.93775 14.2373 9.76986 15.6787 9.76367 17.1253V17.1253Z"
                fill="#F5E6BD"
              />
              <path
                d="M18.0747 12.828V21.7814H24.1947C24.5943 20.2609 24.8068 18.6973 24.8275 17.1253C24.8244 15.679 24.6597 14.2377 24.3364 12.828H18.0747Z"
                fill="#F5E6BD"
              />
              <path
                d="M17.2718 2.01419C14.2831 2.01419 11.3615 2.90044 8.87648 4.56087C6.39147 6.2213 4.45464 8.58133 3.31092 11.3425C2.16719 14.1037 1.86794 17.1421 2.45101 20.0733C3.03407 23.0046 4.47327 25.6971 6.58659 27.8105C8.69992 29.9238 11.3925 31.363 14.3237 31.9461C17.255 32.5291 20.2933 32.2299 23.0545 31.0861C25.8157 29.9424 28.1758 28.0056 29.8362 25.5206C31.4966 23.0356 32.3829 20.114 32.3829 17.1253C32.3829 13.1176 30.7908 9.27402 27.9569 6.44013C25.123 3.60625 21.2795 2.01419 17.2718 2.01419V2.01419ZM28.8129 23.4625H25.394C24.7476 25.4863 23.7918 27.3978 22.5607 29.1292C21.6521 29.5251 20.7016 29.8166 19.7273 29.9981C21.4722 28.1021 22.8151 25.8725 23.6751 23.4436H18.084V30.1964H16.4879V23.4625H10.8684C11.7273 25.8948 13.0703 28.1277 14.8162 30.0264C13.862 29.8469 12.9307 29.5618 12.0395 29.1764C10.804 27.4305 9.84813 25.5028 9.20621 23.4625H5.73065C5.42894 22.9121 5.16698 22.3409 4.94676 21.7531H8.72454C8.37055 20.2356 8.18683 18.6835 8.17676 17.1253C8.17728 15.681 8.32923 14.2407 8.6301 12.8281H4.76732C4.96593 12.242 5.20579 11.6708 5.4851 11.1186H9.08343C9.7586 8.86995 10.8057 6.75025 12.1812 4.84752C13.0535 4.4861 13.9623 4.22011 14.8918 4.05419C13.0129 6.07063 11.595 8.47145 10.7362 11.0903H16.4879V3.90308H18.084V11.1186H23.8357C22.9784 8.50397 21.5638 6.10655 19.6895 4.09197C20.6175 4.24591 21.5263 4.49922 22.4001 4.84752C23.7676 6.73651 24.8113 8.83985 25.4884 11.0714H29.049C29.3283 11.6236 29.5681 12.1948 29.7668 12.7809H25.9323C26.2397 14.2086 26.3948 15.6649 26.3951 17.1253C26.3902 18.6926 26.2097 20.2544 25.8568 21.7814H29.6345C29.4009 22.3606 29.1263 22.9223 28.8129 23.4625Z"
                fill="#F5E6BD"
              />
            </svg>
          </a>
        </div>
      </div>
    </>
  );
};

export const OuterLayer = () => {
  const Close = () => {
    document.querySelector(".Popup_block").classList.remove("active");
    document.querySelector(".outer_layer").classList.remove("active");
    document.documentElement.classList.remove("cm-overflow");
  };
  return (
    <>
      <div className="outer_layer" onClick={Close}></div>
    </>
  );
};
